<template>
    <div class="container-fluid">
        <div class="row justify-content-center" v-if="$can('customers ' + neededRights)">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('customers.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                            <form role="form">

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('customers.internal-contact')}}</label>
                                    <div class="col-md-6">
                                        <kendo-switch v-if="!formdisabled"
                                            :messages="switchInternalMessages"
                                            :width="'70'"
                                            v-model="form.is_internal"
                                            :disabled="formdisabled"
                                        ></kendo-switch>
                                        <input v-if="formdisabled && loadedData" :disabled="formdisabled" ref="firstInput" type="text" class="form-control" name="first_name" :value="$t('general.bool_' + form.is_internal)" >
                                      </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.first-name')}} *</label>

                                    <div class="col-md-6" v-if="!formdisabled">
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <input ref="firstInput" type="text" class="form-control" name="first_name" v-model="form.first_name" >
                                            <span>{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-md-6" v-if="formdisabled">
                                        <input :disabled="formdisabled" ref="firstInput" type="text" class="form-control" name="first_name" v-model="form.first_name" >
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.name')}} *</label>

                                    <div class="col-md-6" v-if="!formdisabled">
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control" name="last_name" v-model="form.last_name">
                                            <span>{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-md-6" v-if="formdisabled">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="last_name" v-model="form.last_name">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.email')}} *</label>
                                    <div class="col-md-6" v-if="!formdisabled">
                                        <ValidationProvider rules="required|email" v-slot="{ errors }">
                                            <input type="email" class="form-control" name="email" v-model="form.email">
                                            <span>{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-md-6" v-if="formdisabled">
                                        <input :disabled="formdisabled" type="email" class="form-control" name="email" v-model="form.email">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.phone')}}</label>

                                    <div class="col-md-6">
                                        <input :disabled="formdisabled" type="tel" class="form-control" name="phone" v-model="form.phone">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.company')}}</label>

                                    <div class="col-md-6">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="company" v-model="form.company">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.department')}}</label>

                                    <div class="col-md-6">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="department" v-model="form.department">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.location')}}</label>

                                    <div class="col-md-6">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="location" v-model="form.location">
                                    </div>
                                </div>


                                <div v-if="!form.is_internal" key="addressBlock">
                                    <div class="form-group row">
                                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.street')}} *</label>
                                        <div class="col-md-6" v-if="!formdisabled">
                                            <ValidationProvider rules="required" v-slot="{ errors }">
                                                <input type="text" class="form-control" name="address" v-model="form.address">
                                                <span>{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6" v-if="formdisabled">
                                            <input :disabled="formdisabled" type="text" class="form-control" name="address" v-model="form.address">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.city')}} *</label>
                                        <div class="col-md-6" v-if="!formdisabled">
                                            <ValidationProvider rules="required" v-slot="{ errors }">
                                                <input type="text" class="form-control" name="city" v-model="form.city">
                                                <span>{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6" v-if="formdisabled">
                                            <input :disabled="formdisabled" type="text" class="form-control" name="city" v-model="form.city">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.zip')}} *</label>
                                        <div class="col-md-6" v-if="!formdisabled">
                                            <ValidationProvider rules="required" v-slot="{ errors }">
                                                <input type="text" class="form-control" name="zip" v-model="form.zip">
                                                <span>{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6" v-if="formdisabled">
                                            <input :disabled="formdisabled" type="text" class="form-control" name="zip" v-model="form.zip">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.country')}} *</label>
                                    <div class="col-md-6" v-if="!formdisabled">
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control" name="country" v-model="form.country">
                                            <span>{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-md-6" v-if="formdisabled">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="country" v-model="form.country">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.language')}} *</label>
                                    <div class="col-md-6" v-if="!formdisabled">
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <select v-model="form.locale" class="form-control">
                                                <option value="" disabled>{{ $t('general.please_choose') }}</option>
                                                <option value="de">Deutsch</option>
                                                <option value="en">English</option>
                                            </select>
                                            <span>{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-md-6" v-if="formdisabled">
                                        <input :disabled="formdisabled" type="text" class="form-control" name="locale" v-model="form.locale">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.additional-info')}}</label>

                                    <div class="col-md-6">
                                        <textarea :disabled="formdisabled" class="form-control" name="additional_info" v-model="form.additional_info"></textarea>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <div class="col-md-6 offset-md-4">
                                        <button type="submit" class="btn btn-secondary" v-if="mode == 'create' || mode == 'edit' || mode == 'display'"
                                                @click.prevent="goBack">
                                            {{$t('buttons.back-abort')}}
                                        </button>

                                        <button class="btn btn-primary" v-if="mode == 'display'"
                                                @click.prevent="editAction">
                                            {{ $t('buttons.edit') }}
                                        </button>

                                        <button :disabled="invalid" type="submit" class="btn btn-success" v-if="mode == 'create'"
                                                @click.prevent="createObject">
                                            {{$t('buttons.create')}}
                                        </button>
                                        <button :disabled="invalid" type="submit" class="btn btn-success" v-if="mode == 'edit'"
                                                @click.prevent="editObject">
                                            {{$t('buttons.save')}}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('customers ' + neededRights)">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>
    export default {
        name: "form-customer",
        props: {
            mode: {
                default: 'create',
                type: String,
            },
            user: String,
            customerid: Number,
            formdisabled: {
                default: false,
                type: Boolean
            }
        },
        data: function () {
            return {
                neededRights: '',
                switchInternalMessages: {
                    checked: this.$t('general.bool_true'),
                    unchecked: this.$t('general.bool_false')
                },
                form:{
                    locale: '',
                    is_internal: false
                },
                loadedData: false
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            init: function () {
                switch(this.mode){
                    case "edit":
                        this.neededRights = "update";
                        break;
                    case "display":
                        this.neededRights = "read";
                        break;
                    default:
                    case "create":
                        this.neededRights = "create";
                }

                // Laden eines bestehenden Kontaktes
                if (this.customerid) {

                    axios
                        .get('/api/customers/id/' + this.customerid)
                        .then(response => {
                            this.loadedData = response.data;
                            console.log("GOT DATA:", this.loadedData);
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {
                        })
                }
            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function () {
                // Formulardaten setzen
                this.form = this.loadedData;

                // Konvertieren, da von Laravel 1 oder 0 rauskommt und nicht true oder false
                this.form.is_internal = Boolean(Number(this.loadedData.is_internal));
            },

            /**
             * Bereitet die Daten zum senden vor
             */
            prepareData(){
            },

            /**
             * Sendet die Formulardaten zum Server und versucht den Kontakt anzulegen
             */
            createObject() {
                this.prepareData();
                // Daten senden
                this.sendForm('post', '/api/customers', this.form)
                    .then(response => {
                        //this.$emit('object-created');
                        swal.fire({
                            title: this.$t('customers.contact-created-success-title'),
                            text: this.$t('customers.contact-created-success-text'),
                            icon: "success",
                            timer: 1500
                        }).then(()=>{
                            this.handleBack('contacts-grid', true, {reload: true, id: this.form.id});
                        })
                    }).
                    catch(errors => {
                        //this.$emit('object-not-created');
                        swal.fire({
                            title: this.$t('customers.contact-created-error-title'),
                            text: this.$t('customers.contact-created-error-text') +" (" + errors + ")",
                            icon: "error"
                        });
                    });
            },

            editAction: function () {
                console.log("edit action", this.customerid);
                this.$router.push({ name: 'contact-edit', params: {
                        customerid: this.customerid,
                        mode: 'edit'
                    }});
            },

            /**
             * Sendet die Formulardaten zum Server und versucht den Kontakt zu bearbeiten
             */
            editObject() {
                // Daten senden
                this.sendForm('put', '/api/customers/update/' + this.form.id, this.form)
                    .then(response => {
                        //this.$emit('object-updated');
                        swal.fire({
                            title: this.$t('customers.contact-updated-success-title'),
                            text: this.$t('customers.contact-updated-success-text'),
                            icon: "success",
                            timer: 1500
                        }).then(() => {
                            this.handleBack('contacts-grid', true, {reload: true, id: this.form.id});
                        });
                    }).
                    catch(errors => {
                        //this.$emit('object-not-updated');
                        swal.fire({
                            title: this.$t('customers.contact-updated-error-title'),
                            text: this.$t('customers.contact-updated-error-text') +" (" + errors + ")",
                            icon: "error"
                        });
                    });
            },

            goBack() {
                //window.location.href = '/customers';
                //this.handleBack('contacts-grid', true, {reload: true, id: this.form.id});
                this.handleBack('contacts-grid', true, {reload: false, id: this.form.id});
            },


            sendForm(method, uri, form) {
                return new Promise((resolve, reject) => {
                    axios[method](uri, JSON.parse(JSON.stringify(form)))
                        .then(response => {
                            resolve(response);
                        })
                        .catch(errors => {
                            reject(errors);
                        });
                });
            },

            /**
             * Eventhandler wird aufgerufen, wenn ein Auftrag angelegt wurde
             */
            onObjectCreated:function(){
                swal.fire({
                    title: "Kontakt wurde angelegt",
                    text: "Der Kontakt wurde angelegt, Sie werden zur Übersicht weitergeleitet",
                    icon: "success",
                    timer: 2000
                }).then(() => {
                    window.location.href = '/customers';
                });
            },

            onObjectUpdated:function(){
                swal.fire({
                    title: "Kontakt wurde aktualisiert",
                    text: "Der Kontakt wurde aktualisiert, Sie werden zur Übersicht weitergeleitet",
                    icon: "success",
                    timer: 2000
                }).then(() => {
                    window.location.href = '/customers';
                });
            },
        }
    }
</script>

<style scoped>

</style>
